const info = [
    {
        $schema: '../../ibc_data.schema.json',
        chain_1: {
            chain_name: 'axelartestnet',
            client_id: '07-tendermint-858',
            connection_id: 'connection-663'
        },
        chain_2: {
            chain_name: 'titantestnet',
            client_id: '07-tendermint-1',
            connection_id: 'connection-1'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-448',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-1',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../../ibc_data.schema.json',
        chain_1: {
            chain_name: 'cosmoshubtestnet',
            client_id: '07-tendermint-3237',
            connection_id: 'connection-3407'
        },
        chain_2: {
            chain_name: 'titantestnet',
            client_id: '07-tendermint-0',
            connection_id: 'connection-0'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-3910',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-0',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../../ibc_data.schema.json',
        chain_1: {
            chain_name: 'osmosistestnet',
            client_id: '07-tendermint-2436',
            connection_id: 'connection-2267'
        },
        chain_2: {
            chain_name: 'titantestnet',
            client_id: '07-tendermint-2',
            connection_id: 'connection-2'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-5969',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-2',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../../ibc_data.schema.json',
        chain_1: {
            chain_name: 'stargazetestnet',
            client_id: '07-tendermint-764',
            connection_id: 'connection-753'
        },
        chain_2: {
            chain_name: 'titantestnet',
            client_id: '07-tendermint-3',
            connection_id: 'connection-3'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-807',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-3',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    }
];
export default info;
